var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('base-sum',{ref:"base",attrs:{"title":_vm.title,"info":_vm.tip,"value":_vm.value,"label":_vm.label,"label1":_vm.label_v}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }